// extracted by mini-css-extract-plugin
module.exports = {"missing-data-container":"style_missing-data-container__2nuGn","missing-data-banner":"style_missing-data-banner__1ERCx","message":"style_message__39i9q","icon":"style_icon__1APE3"};